import React from 'react';
import { ReactComponent as InfoIcon } from '../../assets/images/misc-icons/info.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function StagingNotice() {
  const tooltip = (
    <Tooltip id="staging-tooltip">
      <p className="tooltip-text">
        You can safely test the Fluz API without making transactions on your account. Sign in with your normal Fluz
        account credentials.
      </p>
    </Tooltip>
  );

  return (
    <div id="staging-label" className="d-flex">
      <p className="p-label">Staging environment</p>
      <OverlayTrigger placement="bottom" overlay={tooltip} trigger={['click', 'hover', 'focus']}>
        <InfoIcon className="info-icon" />
      </OverlayTrigger>
    </div>
  );
}
